export default {
  template: `
    <div class="branded-loading">
      <div class="loading-spinner"></div>
    </div>
  `
};
